export const localStorageSet = (key, value) => localStorage.setItem(key, value);
export const localStorageGet = key => localStorage.getItem(key);
